// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__EG5DT","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2-gtk","obliqueLine":"membershipbadge_obliqueLine__2-l0d"};